import Repository from "@/repository";

export default {
    login(payload) {
        return Repository.post('login-register', payload)
    },
    logout(payload){
        return Repository.post('logout', payload)
    },
}